import { render, staticRenderFns } from "./CabecalhoPrincipal.vue?vue&type=template&id=ab63ac86&scoped=true"
import script from "./CabecalhoPrincipal.vue?vue&type=script&lang=js"
export * from "./CabecalhoPrincipal.vue?vue&type=script&lang=js"
import style0 from "./CabecalhoPrincipal.vue?vue&type=style&index=0&id=ab63ac86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab63ac86",
  null
  
)

export default component.exports